<template>
    <div class="col-12 p-4">
        <h2 class="title">
            {{ t("new-general.my-sessions-title") }}
        </h2>
        <div class="col-12 card card-outline card-primary p-2">
            <div class="card-body table-responsive" id="my-table">
                <data-table
                    v-if="!loading"
                    class="table table-striped table-bordered"
                    :data="treinos"
                    :columns="columns"
                    :options="{
                        responsive: true,
                        autoWidth: true,
                        language: {
                            search: t('datatable.search'),
                            zeroRecords: t('datatable.zero'),
                            info: t('datatable.info'),
                            infoFiltered: t('datatable.filter'),
                            paginate: {
                                first: t('datatable.first'),
                                last: t('datatable.last'),
                                next: t('datatable.next'),
                                previous: t('datatable.previous'),
                            },
                        },
                        dom: `<'pb-2'B><'row'<'col-sm-6'l><'col-sm-6'f>><tr><'row'<'col-sm-6'i><'col-sm-6'p>>`,
                    }"
                >
                    <thead>
                        <tr class="table-primary">
                            <th>#</th>
                            <th>{{ t("general.actions") }}</th>
                            <th>{{ t("gifs.title") }}</th>
                            <th>{{ t("treinos.coach") }}</th>
                            <th>{{ t("treinos.category") }}</th>
                            <th>{{ t("treinos.date") }}</th>
                            <th>{{ t("treinos.objectives") }}</th>
                        </tr>
                    </thead>
                </data-table>
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from "datatables.net-vue3";
import DataTableLib from "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import { t } from "@/lang/index.js";
import { mapActions, mapMutations, mapState } from "vuex";

DataTable.use(DataTableLib);

export default {
    name: "VideoSessionsView",
    components: {
        DataTable,
    },
    data() {
        return {
            treinos: [],
            showModal: false,
            columns: [
                { data: "id" },
                {
                    data: null,
                    render: (data) => `
                        <button class='btn btn-flat btn-primary m-1 d-inline' data-url='/video-sessions/${data.id}'>
                            <i class='fa fa-eye' data-url='/video-sessions/${data.id}'></i>
                        </button>
                        <button class='btn btn-flat btn-success m-1 d-inline' data-action='copy' data-id='${data.id}'>
                            <i class='fa fa-copy' data-action='copy' data-id='${data.id}'></i>
                        </button>
                        <button class='btn btn-flat btn-danger m-1 d-inline' data-del='${data.id}'>
                            <i class='fa fa-trash' data-del='${data.id}'></i>
                        </button>
                    `,
                },
                { data: "title" },
                { data: "teacher" },
                { data: "student" },
                { data: "data" },
                {
                    data: null,
                    render: (data) =>
                        `${(data.objectives || "-").substr(0, 50)}`,
                },
            ],
        };
    },
    created() {
        this.SET_LOADING(false);
        document.title = "Sessao de treino com video";
    },
    async mounted() {
        await this.getTreinos();
    },
    computed: {
        ...mapState(["loading"]),
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_USER", "SET_LOADING"]),
        async handleClick(event) {
            if (
                event.target.hasAttribute("data-action") &&
                event.target.getAttribute("data-action") == "copy"
            ) {
                const id = event.target.getAttribute("data-id");
                this.SET_LOADING(true);
                const response = await this.post({
                    url: `fitnes/${id}/duplicate`,
                });
                if (response.status >= 200 && response.status < 300) {
                    alert(this.t("general.done"));
                    this.getTreinos();
                } else {
                    this.SET_LOADING(false);
                    alert(response.data.message);
                }
                this.SET_LOADING(false);
            } else if (event.target.hasAttribute("data-url")) {
                this.$router.push(event.target.getAttribute("data-url"));
            } else if (event.target.hasAttribute("data-del")) {
                const id = event.target.getAttribute("data-del");
                const del = confirm("Deseja realmente eliminar?");

                if (del) {
                    this.SET_LOADING(true);
                    const response = await this.delete({ url: "fitnes/" + id });
                    if (response.status >= 200 && response.status < 300) {
                        alert(t("general.deleted"));
                        this.getTreinos();
                    } else {
                        this.SET_LOADING(false);
                        alert(response.data.message);
                    }
                }
            }
        },
        async getTreinos() {
            this.SET_LOADING(true);
            const response = await this.get({ url: "fitnes?videos=1" });
            console.log(response);
            if (response.status == 200) {
                this.treinos = response.data.fitnes;
            } else if (response.status == 402) {
                alert(response.data.message);
                this.$router.push("/payment");
            } else if (response.status == 401) {
                this.SET_USER(null);
                location = "/login";
            } else {
                alert(response.data.message);
            }
            this.SET_LOADING(false);

            if (!this.loading) {
                this.$el
                    .querySelector("#my-table")
                    .addEventListener("click", this.handleClick);
            }
        },
        t,
    },
};
</script>

<style lang="scss" scoped>
@import "datatables.net-bs5";
</style>
